import React from 'react';
import { Facebook, Instagram, Apple, Smartphone } from 'lucide-react';

const socials = [
  { Icon: Facebook, href: 'https://www.facebook.com/Italianfastdelivery', label: 'Facebook' },
  { Icon: Instagram, href: 'https://www.instagram.com/italianfastdelivery/', label: 'Instagram' },
];

const Footer = () => {
  return (
    <footer className="bg-foreground text-white mt-16">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3">
              <img src="/logo-ifd.jpg" alt="Italian Fast Delivery" className="h-12 w-12 rounded-xl object-cover object-top" />
              <div className="font-display font-extrabold text-lg leading-none">
                ITALIAN<span className="text-primary">Fast</span> DELIVERY
              </div>
            </div>
            <p className="mt-4 max-w-sm text-sm text-white/70">
              Il servizio di cibo a domicilio numero uno in Calabria. Alle vostre consegne ci pensiamo noi!
            </p>
            <div className="mt-5 flex gap-3">
              {socials.map(({ Icon, href, label }) => (
                <a key={label} href={href} target="_blank" rel="noopener noreferrer" aria-label={label} className="flex h-10 w-10 items-center justify-center rounded-full bg-white/10 hover:bg-primary transition-colors">
                  <Icon className="h-5 w-5" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-display font-semibold mb-4">Azienda</h4>
            <ul className="space-y-2.5 text-sm text-white/70">
              {['Chi siamo', 'Lavora con noi', 'Blog', 'Stampa'].map((l) => (
                <li key={l}><a href="#" className="hover:text-primary transition-colors">{l}</a></li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-display font-semibold mb-4">Per te</h4>
            <ul className="space-y-2.5 text-sm text-white/70">
              {['Diventa rider', 'Aggiungi il tuo ristorante', 'Centro assistenza', 'Contatti'].map((l) => (
                <li key={l}><a href="#" className="hover:text-primary transition-colors">{l}</a></li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-display font-semibold mb-4">Scarica l'app</h4>
            <div className="space-y-3">
              <a href="https://apps.apple.com/it/app/italian-fast-delivery/id1530610317" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 rounded-xl bg-white/10 hover:bg-white/20 transition-colors px-4 py-2.5">
                <Apple className="h-6 w-6" />
                <span className="text-sm"><span className="block text-[11px] text-white/60">Scarica su</span>App Store</span>
              </a>
              <a href="https://play.google.com/store/apps/details?id=it.resmedia.fast_delivery&hl=it" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 rounded-xl bg-white/10 hover:bg-white/20 transition-colors px-4 py-2.5">
                <Smartphone className="h-6 w-6" />
                <span className="text-sm"><span className="block text-[11px] text-white/60">Disponibile su</span>Google Play</span>
              </a>
            </div>
          </div>
        </div>
        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-white/60">
          <p>© {new Date().getFullYear()} Italian Fast Delivery. Tutti i diritti riservati.</p>
          <div className="flex gap-5">
            <a href="#" className="hover:text-primary transition-colors">Privacy</a>
            <a href="#" className="hover:text-primary transition-colors">Termini</a>
            <a href="#" className="hover:text-primary transition-colors">Cookie</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
